class SizeBar extends HTMLElement {
  constructor() {
    super();
    this.subtotalArr = document.querySelectorAll('.totals__subtotal-value');
    this.buttonsArr = this.querySelectorAll('.add-variant-button');
    this.progressBar = document.querySelector('progress-bar');
    this.cartDrawer = document.querySelector('cart-drawer');
    this.buttonsArr = this.querySelectorAll('.add-variant-button');
    this.toggleButton = this.querySelector('button.add-button');
    this.closeButton = this.querySelector('.close-button');
    this.spinner = this.querySelector('.icon-spinner');
    this.sizeBarHeader = this.querySelector('.size-bar__header');
    this.actionPill = this.querySelector('.action-pill');
    this.debouncedOnClick = debounce((event) => {
      this.handleClick(event);
    }, 300);
  }

  connectedCallback() {
    // size buttons
    if (this.buttonsArr) {
      this.buttonsArr.forEach((button) => {
        button.addEventListener('click', this.debouncedOnClick.bind(this));
        button.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      });
    };

    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggleSheet.bind(this));
      this.closeButton.addEventListener('click', this.toggleSheet.bind(this));
    }
  }

  closeAll() {
    document.querySelectorAll('.add-button').forEach((sizebar) => {
      sizebar.setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden');
    });
  }

  toggleSheet() {
    document.querySelectorAll('.add-button').forEach((sizebar) => {
      if (sizebar != this.toggleButton) {
        sizebar.setAttribute('aria-expanded', false);
      }
    });

    if (this.toggleButton.getAttribute('aria-expanded') == 'true') {
      this.toggleButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
    } else {
      this.toggleButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
    }

  }

  handleMouseEnter(event) {
    var desktop = false;
    (window.innerWidth > 768) ? (desktop = true) : (desktop = false);

    if(desktop) {
      this.actionPill.textContent = event.target.dataset.action;

      if (event.target.dataset.action == "Pre-order") {
        this.sizeBarHeader.classList.add("preorder");
      } else {
        this.sizeBarHeader.classList.remove("preorder"); 
      }
    }
  }

  handleClick(event) {
    this.spinner.classList.remove('hidden');

    var data;

    if (event.target.dataset.action == "Pre-order") {
      data = {
        'id': parseInt(event.target.dataset.variant),
        'quantity': 1,
        properties: {
          'Status': 'Pre-order'
        }
      };
    } else {
      data = {
        'id': parseInt(event.target.dataset.variant),
        'quantity': 1
      };
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify(data)
      })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.log(response.description);
          return;
        }

        return fetch('/?section_id=intus-header', {
          method: 'get',
          'Content-Type': 'application/json'
        });
      })
      .then((data) => data.text())
      .then((dataText) => {

        const updatedCartIcon = new DOMParser()
          .parseFromString(dataText, 'text/html')
          .getElementById('icon-cart').innerHTML;
        document.getElementById('icon-cart').innerHTML = updatedCartIcon;

        this.closeAll();

        this.spinner.classList.add('hidden');
        window.monster_refresh(true);

      })
      .catch((e) => {
        console.error("Error " + e);
      });
  }
}
customElements.define('size-bar', SizeBar);
